import { theme } from '../../../config/tailwind.config';
import { STATUSES } from '../constants';
function statusColor(state) {
  switch (state.toLowerCase()) {
    case STATUSES.DRAFT:
      return theme.extend.colors.yellow;
    case STATUSES.COMPLETE:
      return theme.extend.colors['dark-green'];
    case STATUSES.DECLINED:
      return theme.extend.colors.red;
    default:
      return '';
  }
}
export default statusColor;
//# sourceMappingURL=statusColor.js.map